import { Directive, ViewContainerRef } from '@angular/core';

/* tslint:disable */
@Directive({
  selector: '[dw-dynamic]',
})
export class DataWindowDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}